import { MessageCircle, Phone, Mail, MapPin, UserPlus, Globe } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL || "";
// Replace with the MOHA MOTORS logo URL once provided
const MOHA_LOGO_URL = "";

export const CARD = {
  name: "Mohamed Jedda",
  title: "Administrator",
  company: "MOHA MOTORS",
  address: "Pipera 44, Bucharest, Romania",
  phone: "+40 733 523 514",
  email: "mohamotorss@gmail.com",
  website: "https://mohamotors.com",
};

const ACTIONS = [
  { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: "https://wa.me/40733523514", external: true, primary: true },
  { id: "call", label: "Call", icon: Phone, href: "tel:+40733523514" },
  { id: "email", label: "Email", icon: Mail, href: "mailto:mohamotorss@gmail.com" },
  { id: "maps", label: "Map", icon: MapPin, href: "https://www.google.com/maps/search/?api=1&query=Pipera+44%2C+Bucharest%2C+Romania", external: true },
];

function Logo() {
  if (MOHA_LOGO_URL) return <img src={MOHA_LOGO_URL} alt="MOHA MOTORS" className="h-16 w-auto mx-auto object-contain" data-testid="card-logo" />;
  return (
    <div data-testid="card-logo" className="text-center select-none">
      <p className="text-3xl font-black tracking-[0.25em] text-white">MOHA</p>
      <p className="text-xs font-bold tracking-[0.6em] text-[#FF7A00] mt-1 pl-[0.6em]">MOTORS</p>
    </div>
  );
}

function ActionButton({ a }) {
  const Icon = a.icon;
  return (
    <a href={a.href} data-testid={`card-btn-${a.id}`} {...(a.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      className={`group flex flex-col items-center justify-center gap-2 rounded-2xl py-4 border transition-[transform,background-color,border-color] duration-200 active:scale-95 hover:-translate-y-0.5 ${a.primary ? "bg-[#FF7A00] border-[#FF7A00] text-black hover:bg-[#ff8c1f]" : "bg-white/[0.03] border-white/10 text-white hover:border-[#FF7A00]/60"}`}>
      <Icon className={`w-5 h-5 ${a.primary ? "" : "text-[#FF7A00]"}`} />
      <span className="text-xs font-semibold tracking-wide">{a.label}</span>
    </a>
  );
}

const InfoRow = ({ icon: Icon, children, href, testid }) => (
  <a href={href} data-testid={testid} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer"
    className="flex items-center gap-4 py-3.5 border-b border-white/[0.06] last:border-0 text-sm text-white/80 hover:text-white transition-colors">
    <Icon className="w-4 h-4 text-[#FF7A00] flex-shrink-0" />
    <span className="break-all">{children}</span>
  </a>
);

export default function BusinessCardPage() {
  return (
    <div className="min-h-screen bg-black text-white font-['Exo_2'] flex items-start sm:items-center justify-center px-5 py-10" data-testid="business-card-page">
      <div className="w-full max-w-sm animate-in fade-in slide-in-from-bottom-4 duration-700">
        <Logo />
        <div className="mt-10 text-center">
          <h1 className="text-4xl font-bold tracking-tight" data-testid="card-name">{CARD.name}</h1>
          <p className="mt-2 text-sm text-white/60"><span className="text-[#FF7A00] font-semibold">{CARD.title}</span> · {CARD.company}</p>
        </div>
        <div className="mx-auto mt-8 h-px w-16 bg-[#FF7A00]" />
        <div className="mt-8 grid grid-cols-4 gap-2.5">
          {ACTIONS.map(a => <ActionButton key={a.id} a={a} />)}
        </div>
        <a href={`${API}/api/public/vcard/mohamed-jedda`} data-testid="card-btn-save-contact"
          className="mt-3 w-full flex items-center justify-center gap-2 rounded-2xl py-4 bg-white text-black font-bold text-sm hover:bg-white/90 active:scale-[0.98] transition-[transform,background-color]">
          <UserPlus className="w-5 h-5" /> Save Contact
        </a>
        <div className="mt-8 rounded-2xl bg-white/[0.03] border border-white/10 px-5">
          <InfoRow icon={Phone} href="tel:+40733523514" testid="card-info-phone">{CARD.phone} <span className="text-white/40">· Mobile</span></InfoRow>
          <InfoRow icon={MessageCircle} href="https://wa.me/40733523514" testid="card-info-whatsapp">{CARD.phone} <span className="text-white/40">· WhatsApp</span></InfoRow>
          <InfoRow icon={Mail} href={`mailto:${CARD.email}`} testid="card-info-email">{CARD.email}</InfoRow>
          <InfoRow icon={MapPin} href={ACTIONS[3].href} testid="card-info-address">{CARD.address}</InfoRow>
          <InfoRow icon={Globe} href={CARD.website} testid="card-info-website">mohamotors.com</InfoRow>
        </div>
        <a href={CARD.website} target="_blank" rel="noopener noreferrer" data-testid="card-btn-website"
          className="mt-3 w-full flex items-center justify-center gap-2 rounded-2xl py-4 border border-[#FF7A00]/50 text-[#FF7A00] font-semibold text-sm hover:bg-[#FF7A00]/10 transition-colors">
          <Globe className="w-5 h-5" /> Visit Website
        </a>
        <p className="mt-10 text-center text-[10px] tracking-[0.3em] text-white/45 uppercase">Digital Business Card</p>
      </div>
    </div>
  );
}
